import BaseListagem from "components/BaseListagem";
import ModalGerarAuditoria from "pages/auditoria5s/execucao/modal/ModalGerarAuditoria";
import Setor from "model/administracao/cadastro/Setor";
import Auditoria from "model/auditoria5s/auditoria/Auditoria";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTable, DataTableFilterMeta, DataTableStateEvent } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AuditoriaService from "service/auditoria5s/AuditoriaService";
import ExecucaoAuditoriaService from "service/auditoria5s/ExecucaoAuditoriaService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData, converterDataHora } from "utils/convert";
import { dateFilterTemplate, DateMatchModeOptions, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, IdMatchModeOptions, ListMatchModeOptions, NumberMatchModeOptions, statusFilterTemplate, TextMatchModeOptions } from "utils/filterUtils";
import { useFilter } from "contexts/FilterContext";
import Pageable from "model/page/Pageable";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import AcaoAuditoria from "model/auditoria5s/auditoria/AcaoAuditoria";
import AcaoAuditoriaService from "service/auditoria5s/AcaoAuditoriaService";

const auditoriaService = new AuditoriaService();
const acaoAuditoriaService = new AcaoAuditoriaService();

export default function MinhasAcoesAuditoriaPage() {
    const filterContext = useFilter();

    const [setoresDisponiveis, setSetoresDisponiveis] = useState<Setor[]>([]);
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [rows, setRows] = useState<Auditoria[]>([]);
    const [pageable, setPageable] = useState(filterContext.pageables["minhasAcoes"] ? filterContext.pageables["minhasAcoes"] : new Pageable(0, 10, "nome,ASC", 0));
    const [totalElements, setTotalElements] = useState<number>(0);

    const [visibleModalGerar, setVisibleModalGerar] = useState(false);

    const navigate = useNavigate();


    const defaultFilters: DataTableFilterMeta = {
        numero: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        setor: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        createdAt: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataLimite: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        responsavel: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        }
    };
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);

    const setorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={setoresDisponiveis} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    useEffect(() => {
        auditoriaService.getSetoresDisponiveis().then(response => setSetoresDisponiveis(response)).catch(() => setSetoresDisponiveis([]));
    }, []);

    useEffect(() => {
        if (filterContext.filters["minhasAcoes"]) {
            setFilters(filterContext.filters["minhasAcoes"])
        }
        setFiltrando(true);
    }, []);

    useEffect(() => {
        setFiltrando(true);
    }, [filters, pageable]);

    useEffect(() => {
        if (filtrando) {
            filterContext.updateFilters("minhasAuditorias", filters);
            filterContext.updatePageable("minhasAuditorias", pageable);


            acaoAuditoriaService
                .pesquisarMinhas(pageable, filters)
                .then(lista => {
                    setFiltrando(false);
                    setRows(lista.content);
                    setTotalElements(lista.totalElements);
                })
                .catch(err => {
                    setFiltrando(false);
                });
        }
    }, [filtrando, pageable]);

    const onPage = (event: DataTableStateEvent) => {

        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
        setFiltrando(true);

    };

    function navigateToResponder(acaoAuditoria: AcaoAuditoria): void {
        let url = `/minhasAcoesAuditoria/${acaoAuditoria.id}`;
        navigate(`${url}`);

    }

    function getHeader() {

        return (
            <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                <div></div>
                <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>{'Minhas Auditorias'}</span>
                <div >
                    <Button type="button" icon="pi pi-filter-slash" label="Limpar" outlined onClick={clearFilter} style={{ marginRight: 8 }} />
                </div>
            </div>
        )
    }

    const clearFilter = () => {
        setFilters(defaultFilters || {});
    }

    return (
        <>
            {visibleModalGerar ? <ModalGerarAuditoria
                visible={visibleModalGerar}
                setVisible={(e) => { setVisibleModalGerar(e) }}
                onConfirm={() => { setFiltrando(true); }}
            /> : null}
            <DataTable
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                currentPageReportTemplate="{first} - {last} de {totalRecords}"
                filters={filters}
                onFilter={(e) => { setFilters(e.filters) }}
                header={getHeader()}
                value={rows} lazy dataKey="id" paginator
                first={pageable.first} rows={10} totalRecords={totalElements} onPage={onPage}
                loading={filtrando} tableStyle={{ minWidth: '75rem' }}
                emptyMessage="Nenhum registro encontrado"
            >
                <Column
                    field="itemAuditoria.classeAuditoria.auditoria.numero" header="Nr. Auditoria" filterField="numero"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column
                    field="itemAuditoria.classeAuditoria.auditoria.setor.nome" header="Setor" filterField="setor"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={setorFilterTemplate}
                />
                <Column
                    field="nome" header="Nome"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}
                />
                <Column field="createdAt" header="Criado em" body={(rowData) => converterData(rowData.createdAt)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="dataLimite" header="Dt. Limite" body={(rowData) => converterData(rowData.dataLimite)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="status" header="Status" filterField="status"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} 
                    filterElement={(options)=> statusFilterTemplate(options, acaoAuditoriaService.getStatusFilter())}
                    body={(rowData) => acaoAuditoriaService.getStatus(rowData.status)}
                />
                <Column body={(rowData: AcaoAuditoria) => <Button label={rowData.status == "FINALIZADO" ? "Visualizar" : "Responder"} onClick={() => navigateToResponder(rowData)} />} />
            </DataTable>
        </>

    )
}
